import article from "components/templates/article/article";
import articleDsfr from "components/templates/articleDsfr/articleDsfr";
import comedec from "components/templates/comedec/comedec";
import contact from "components/templates/contact/contact";
import counter from "components/templates/counter/counter";
import floatingImage from "components/templates/floatingImage/floatingImage";
import geolocalisation from "components/templates/geolocalisation/geolocalisation";
import geolocalisationDsfr from "components/templates/geolocalisationDsfr/geolocalisationDsfr";
import glossary from "components/templates/glossary/glossary";
import glossaryDsfr from "components/templates/glossaryDsfr/glossaryDsfr";
import help from "components/templates/help/help";
import helpMairie from "components/templates/help/helpMairie";
import helpDetail from "components/templates/helpDetail/helpDetail";
import helpDsfr from "components/templates/helpDsfr/helpDsfr";
import home from "components/templates/home/home";
import homeDsfr from "components/templates/homeDsfr/homeDsfr";
import homeMairie from "components/templates/homeMairie/homeMairie";
import homeProcessSites from "components/templates/homeProcessSites/homeProcessSites";
import knowEverything from "components/templates/knowEverything/knowEverything";
import knowEverythingDsfr from "components/templates/knowEverythingDsfr/knowEverythingDsfr";
import missions from "components/templates/missions/missions";
import missionsDsfr from "components/templates/missionsDsfr/missionsDsfr";
import allNews from "components/templates/news/allNews";
import lastNews from "components/templates/news/lastNews";
import news from "components/templates/news/news";
import pageLinks from "components/templates/pageLinks/pageLinks";
import pageLinksDsfr from "components/templates/pageLinksDsfr/pageLinksDsfr";
import process from "components/templates/process/process";
import processDsfr from "components/templates/processDsfr/processDsfr";
import processes from "components/templates/processes/processes";
import processesDsfr from "components/templates/processesDsfr/processesDsfr";
import standard from "components/templates/standard/standard";
import webcallback from "components/templates/webcallback/webcallback";
import who from "components/templates/who/who";
import cyber from "./cyber/cyber";

export default [
  home,
  homeDsfr,
  missions,
  missionsDsfr,
  standard,
  who,
  article,
  articleDsfr,
  pageLinks,
  pageLinksDsfr,
  helpDetail,
  process,
  processDsfr,
  processes,
  processesDsfr,
  homeProcessSites,
  knowEverything,
  knowEverythingDsfr,
  contact,
  geolocalisation,
  geolocalisationDsfr,
  help,
  helpDsfr,
  glossary,
  glossaryDsfr,
  homeMairie,
  floatingImage,
  comedec,
  news,
  allNews,
  lastNews,
  helpMairie,
  counter,
  webcallback,
  cyber,
];

export const excludedTemplatesForPageCreation = [home, homeMairie, homeProcessSites, helpMairie];

export const oldHomeTemplates = [home.key, homeMairie.key, homeProcessSites.key];

export const templatesWithoutOldShare = [
  news.key,
  allNews.key,
  lastNews.key,
  articleDsfr.key,
  geolocalisationDsfr.key,
  webcallback.key,
  helpDetail.key,
  comedec.key,
  standard.key,
  who.key,
  counter.key,
  cyber.key,
];

export const DSFRTemplatesWithBanner = [
  homeDsfr.key,
  processesDsfr.key,
  pageLinksDsfr.key,
  processDsfr.key,
  knowEverythingDsfr.key,
  missionsDsfr.key,
  glossaryDsfr.key,
  helpDsfr.key,
  allNews.key,
  lastNews.key,
  who.key,
];
